<template>
  <div class="">

    <template v-if="isLoading">
      <div class="w-100" style="padding: 150px 0;">
        <spinner size="large"></spinner>
      </div>
    </template>

    <template v-else>
      <div class="insight_chart_container">

        <template v-if="insight && insight.type">
          <template v-if="reportReady">

            <div class="hd_bar">
              <div class="hd_ic">
                <span class="ic-insight"></span>
              </div>
              <div class="hd_txt">
                <span class="title_txt">{{insight.title}}</span>
              </div>
            </div>

            <div class="insight_chart">
              <div class="insight_chart_inner">
                <bar-chart v-if="insight.type === 'bar'" :data="reportData" :title="insight.title"></bar-chart>
                <sankey v-if="insight.type === 'sankey'" :data="reportData" :title="insight.title"></sankey>
                <tree-structure v-if="insight.type === 'tree'" :title="insight.title"></tree-structure>
                <fastest-growing-careers-list v-if="insight.type === 'fastest-list'" :data="reportData"  :title="insight.title"></fastest-growing-careers-list>
                <largest-employment-careers-list v-if="insight.type === 'largest-list'" :data="reportData" :title="insight.title"></largest-employment-careers-list>
              </div>
            </div>

            <nav class="layout-footer footer stream_footer bg-footer-theme sm_back_btn">
              <div class="container-fluid d-flex flex-wrap justify-content-between">

                <div class="back_btn">
                  <b-link class="footer-link" @click="closeSelectedReport">
                    <span class="ic-arrow-left2"></span>
                    <span class="btn_txt">back</span>
                  </b-link>
                </div>

                <div class="footer_links_with_back_btn">
                  <span class="footer_txt">{{insight.title}}</span>
                </div>

              </div>
            </nav>

          </template>
        </template>

      </div>
    </template>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import BarChart from './BarChart'
import Sankey from './Sankey'
import TreeStructure from './TreeStructure'
import FastestGrowingCareersList from './FastestGrowingCareersList'
import LargestEmploymentCareersList from './LargestEmploymentCareersList'
export default {
  name: 'explore-insight',
  props: ['insight'],
  components: {
    Navbar,
    BarChart,
    Sankey,
    TreeStructure,
    FastestGrowingCareersList,
    LargestEmploymentCareersList
  },
  data: () => {
    return {
      reportData: {},
      isLoading: true,
      reportReady: false
    }
  },

  mounted () {
    this.loadInsight()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadReport',
      'setCurrentFacet',
      'loadFastestGrowingCareers',
      'loadCareersWithLargestEmployment',
      'loadUserObj',
      'loadInstitutionPackage'
    ]),
    closeSelectedReport () {
      this.$parent.selectedInsight = null
      this.$parent.showSelectedReport = false
    },
    async loadInsight () {
      await this.loadUserObj()
      await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
      if (this.insight) {
        if (this.insight.type === 'largest-list') {
          let res = await this.loadCareersWithLargestEmployment()
          this.reportData = res.content
          this.reportReady = true
          this.isLoading = false
        } else if (this.insight.type === 'fastest-list') {
          let res = await this.loadFastestGrowingCareers()
          this.reportData = res.content
          this.reportReady = true
          this.isLoading = false
        } else {
          var query = 'reportName=' + this.insight.reportName + '&count=100'
          if (this.insight.targetName && this.insight.targetName.length > 0) {
            query = query + '&targetName=' + this.insight.targetName
          }
          this.loadReport(query).then(res => {
            this.reportData = res
            this.reportReady = true
            this.isLoading = false
          })
        }
      }
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'enabledFeatures': state => state.dashboard.enabledFeatures,
      'currentFacet': state => state.explore.currentFacet
    })
  }
}
</script>

<style scoped>
  body {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreInsight.vue